import { __extends } from "tslib";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
import { WriteGetObjectResponseRequest } from "../models/models_1";
import { deserializeAws_restXmlWriteGetObjectResponseCommand, serializeAws_restXmlWriteGetObjectResponseCommand, } from "../protocols/Aws_restXml";
var WriteGetObjectResponseCommand = (function (_super) {
    __extends(WriteGetObjectResponseCommand, _super);
    function WriteGetObjectResponseCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    WriteGetObjectResponseCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "WriteGetObjectResponseCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: WriteGetObjectResponseRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    WriteGetObjectResponseCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlWriteGetObjectResponseCommand(input, context);
    };
    WriteGetObjectResponseCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlWriteGetObjectResponseCommand(output, context);
    };
    return WriteGetObjectResponseCommand;
}($Command));
export { WriteGetObjectResponseCommand };
